// componente per la visualizzazione della pagina di inserimento/modifica di un pannello (componente sinistra)
// nella pagina "Pannelli"

import { Component, OnInit, ViewChild, AfterViewChecked } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material';
import { MatSelectModule } from '@angular/material/select';
import { AlertService } from 'src/app/service/alert.service';

import { ApiService } from '../../../../service/api.service';
import { AuthenticationService } from '../../../../service/authentication.service';
import { UtilsService } from '../../../../service/helper/utils.service';
import { Injectable } from '@angular/core';

import { Users } from '../users.model';
import { UsersService } from '../users.service';
import { UsersListComponent } from '../users-list/users-list.component';

@Component({
  selector: 'app-users-edit',
  templateUrl: './users-edit.component.html',
  styleUrls: ['./style.scss']
})

@Injectable()
export class UsersEditComponent implements OnInit, AfterViewChecked {
  private subscription: Subscription;
  @ViewChild('f', { static: true }) usersForm: NgForm;
  @ViewChild(MatTabGroup, { static: true }) tabGroup: MatTabGroup;

  // inizializzazione array e campi utilizzati nella gestione pannelli
  editMode = false; // variabile posta a true se è attiva la modifica di un pannello
  oldId = 0; // ID del pannello prima della modifica
  editUsersId = 0; // ID del pannello da modificare
  users: Users; // pannello selezionato
  address = "" // indirizzo pannello preimpostato come stringa vuota
  comment = ''; // commento pannello preimpostato come stringa vuota
  profiled: string // profilo utente
  systemss = []
  profiles = ["Admin", "User", "SuperAdmin"]

  constructor(private als: AlertService, private usersService: UsersService, private usersList: UsersListComponent, private auth: AuthenticationService,
    public dialog: MatDialog,
    public dataStorageService: ApiService, private utilsService: UtilsService) { }

  // da inserire per abilitare l'aggiornamento dei form
  ngAfterViewChecked() {
  }
  ngAfterViewInit() {
  }
  // metodo richiamato all'inizio quando si entra nella pagina
  ngOnInit() {
    var me = this

    // in base al profilo loggato si definiscono le categorie selezionabili dall'utente
    this.profiled = this.auth.currentUserValue.profile

    // si riempie la form coi valori preimpostati
    this.subscription = this.usersService.usersEditMode.subscribe(
      (id: number) => {
        me.users = me.usersService.getUsersByIndex(id);
        me.oldId = me.users.id
        var syss = []
        if (me.users.systems != "") {
          me.users.systems = me.users.systems.replace("[", "")
          me.users.systems = me.users.systems.replace("]", "")
          syss = me.users.systems.split(",")
        }

        me.users.profile = me.users.profile.charAt(0).toUpperCase() + me.users.profile.slice(1)

        this.usersForm.setValue({
          username: me.users.username ? me.users.username : "",
          firstname: me.users.firstname ? me.users.firstname : "",
          lastname: me.users.lastname ? me.users.lastname : "",
          profile: me.users.profile ? me.users.profile : "",
          email: me.users.email ? me.users.email : "",
          systems: syss
        });
        me.editUsersId = id;
        me.editMode = true;
      }
    );
  }

  // metodo richiamato al submit del form (per inserimento o modifica)
  onSubmit(form: NgForm) {
    var me = this
    const value = form.value;
    me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

    // se non si è in modalità modifica si richiamano tutti i servizi di aggiunta nuovo pannello...
    if (!me.editMode) {

      // l'opportuno servizio restituisce l'ID da inserire per il nuovo pannello (incrementando di 1 il massimo già esistente)
      this.dataStorageService.getMaxUsers().subscribe(v => {

        // si crea il nuovo pannello coi valori digitati dall'utente e l'ID restituito dal back-end
        var mess = new Users(v,
          value.username,
          value.firstname,
          value.lastname,
          value.profile,
          value.email,
          value.systems
        );
        mess.systems = JSON.stringify(mess.systems)

        // si richiama il servizio di back-end per l'inserimento del pannello
        me.dataStorageService.storeUsers(mess)

        // si richiamano i servizi di aggiornamento tabella
        me.users = mess;
        me.usersService.addUsers(mess);

        // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
        setTimeout(function () {
          me.utilsService.hideLoader();
          me.onClear();
        }, 1000)
      })

      // se si è in modalità modifica si richiamano tutti i servizi di modifica pannello...
    } else {

      // si crea il pannello coi valori digitati dall'utente e l'ID non cambiato
      var new_users = new Users(me.oldId,
        value.username,
        value.firstname,
        value.lastname,
        value.profile,
        value.email,
        value.systems
      );

      // si verifica se sono cambiati i sistemi dell'utente locale
      var systemchanged = false
      if (me.users.systems.split(",").sort().toString() != value.systems.sort().toString() && me.auth.currentUserValue.username == value.username) {
        systemchanged = true
      }

      new_users.systems = JSON.stringify(new_users.systems)

      // si richiamano i servizi di aggiornamento tabella
      me.users = new_users;
      me.users.id = me.editUsersId;
      var res = this.usersList.getIndex(this.users.id)
      me.usersService.updateUsers(res, me.users);
      me.users.id = me.oldId

      // si richiama il servizio di back-end per l'inserimento del pannello
      me.dataStorageService.updateUsers(me.users)

      // dopo un secondo si rimuove l'animazione di caricamento e si svuota la form di inserimento
      setTimeout(function () {
        me.utilsService.hideLoader();
        me.onClear();
      }, 1000)

      // se sono cambiati i sistemi dell'utente locale si richiede il login
      if (systemchanged) {

        const conf = me.als.confirm('Ripetere login per rendere effettive le modifiche').subscribe(x => {
          if (x === true) {
            me.auth.logout()
          }
          conf.unsubscribe();

        });

      }
    }
  }

  // metodo che ripulisce la form di inserimento messaggio
  onClear() {
    this.usersForm.setValue({
      username: "",
      firstname: "",
      lastname: "",
      profile: "",
      email: "",
      systems: ""
    });
    this.editMode = false;
  }

  // metodo richiamato alla cancellazione di un pannello
  onDelete() {
    var me = this

    const conf = me.als.confirm("Sei sicuro di voler eliminare l'utente?").subscribe(x => {
      if (x === true) {
        me.utilsService.showLoader(); // viene mostrata l'animazione di caricamento

        // ... viene cancellato il messaggio dal backend...
        me.dataStorageService.deleteUsers(me.users.id)

        // ...il messaggio viene eliminato dalla tabella...
        me.usersService.deleteUsers(me.users.id);

        // ...viene ripulito la form...
        me.onClear();
        me.editMode = false;

        // dopo 1 secondo scompare l'animazione di caricamento
        setTimeout(function () {
          me.utilsService.hideLoader();
        }, 1000)
      }
      conf.unsubscribe();

    });


  }

  // richiamato per ripulire la form di inserimento
  onAbort() {
    this.onClear();
  }
}

